<script>
import BtnExpand from '@/components/ui/BtnExpand.vue';
import BtnEye from '@/components/ui/BtnEye.vue';
import BaseLink from '@/components/BaseLink.vue';
import TaskRow from '@/components/task/TaskRow.vue';

export default {
  name: 'GanttAside',
  components: { BtnEye, TaskRow, BtnExpand, BaseLink }, // eslint-disable-line
  props: {
    data: Array,
    showStages: Boolean,
  },
};
</script>

<template lang="pug">
  .gantt-aside
    .project-list(v-for="project in data" :key="project.id")
      .project-tile()
        BaseLink.project-name(:to="{ name: 'project-stages', params: { projectId: project.id } }" target='_blank') {{ project.name }}
        BtnEye(v-if="!project.collapsed" :hidden="!showStages" @toggle="$emit('toggleStageVisibility', !showStages)")
        BtnExpand(v-if="!project.collapsed && showStages" :expanded="!project.areAllStagesFolded" @toggle="$emit('toggleStageFoldingByProject', { id: project.id, expand: project.areAllStagesFolded })")
        BtnExpand(:expanded="!project.collapsed" @toggle="$emit('toggleProjectFolding', project.id)" single)
      template(v-if="project.children.length && !project.collapsed")
        .stage-list(v-if="showStages")
          template(v-for="stage in project.children")
            .stage-tile
              BtnExpand(:expanded="!stage.collapsed" @toggle="$emit('toggleStageFolding', stage.id)")
              .stage-name.text {{ stage.name }}
            .task-list(v-if="!stage.collapsed")
              TaskRow(
                v-for="task in stage.children"
                :key="task.id"
                :task="task"
                :editable="task.isEditable && !task.isClosed"
                :projectMembers="project.members"
                :to="{ name: 'task-detail', params: { projectId: project.id, stageId: task.stage.id, taskId: task.id } }"
                @update="$emit('taskUpdate', $event)"
              )
        .task-list.no-padding(v-else)
          TaskRow(
            v-for="task in project.children"
            :key="task.id"
            :task="task"
            :editable="task.isEditable && !task.isClosed"
            :projectMembers="project.members"
            :to="{ name: 'task-detail', params: { projectId: project.id, stageId: task.stage.id, taskId: task.id } }"
            @update="$emit('taskUpdate', $event)"
           )
</template>

<style scoped lang="scss">
  .gantt-aside {
    padding-top: 40px;
    display: grid;
    gap: 10px;
  }

  .project-list, .stage-list {
    display: grid;
    gap: 10px;
  }

  .task-list {
    display: grid;
    gap: 10px;
    padding-left: 25px;

    &.no-padding {
      padding-left: 0;
    }
  }

  .project-tile {
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    button {
      flex-shrink: 0;
    }
  }

  .project-name {
    margin-right: auto;
  }

  .stage-tile {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    height: 40px;
    border-radius: 4px;
    padding: 0 25px;
    background: #fff;
  }

  .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.01em;
    color: #1E3147;
    max-width: 325px;
  }
</style>
